import CategoryBg from "./CategoryBg";
import Scroll from "./Scroll";

function CategoryListBg() {
  return (
    <div className="my-8">
      <Scroll>
        <CategoryBg
          className="flex-shrink-0 bg-gradient-to-r from-pink-700 to-pink-500"
          title="For You"
          line
        />
        <CategoryBg
          className="flex-shrink-0 bg-gradient-to-r from-yellow-500 to-yellow-400"
          title="Produk Populer WIB"
        />
        <CategoryBg
          className="flex-shrink-0 bg-gradient-to-r from-green-700 to-green-500"
          title="Muslim Fash Forward"
        />
        <CategoryBg
          className="flex-shrink-0 bg-gradient-to-r from-purple-700 to-purple-500"
          title="Special Discount"
        />
        <CategoryBg
          className="flex-shrink-0 bg-gradient-to-r from-yellow-500 to-yellow-400"
          title="Mainan Anak - Anak"
        />
        <CategoryBg
          className="flex-shrink-0 bg-gradient-to-r from-pink-700 to-pink-500"
          title="Tablet"
        />
        <CategoryBg
          className="flex-shrink-0 bg-gradient-to-r from-green-700 to-green-500"
          title="Novel & Sastra"
        />
      </Scroll>
    </div>
  );
}

export default CategoryListBg;
